
const m = window.require("discourse/lib/offset-calculator");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
